'use client'

import React, { useState, useEffect } from 'react'
import { Plus, X } from 'lucide-react'

const categories = {
  index: 'インデックス',
  stock: '個別株価',
  financial: '財務指標',
  macro: 'マクロ経済指標',
}

const subCategories = {
  index: {
    nikkei: { name: '日経平均', value: '32,034' },
    topix: { name: 'TOPIX', value: '2,701.54' },
    dowJones: { name: 'NY ダウ', value: '43,268.94' },
    sp500: { name: 'S&P 500', value: '5,916.98' },
  },
  stock: {
    toyota: { name: 'トヨタ自動車', value: '2,450' },
    sony: { name: 'ソニーグループ', value: '13,590' },
  },
  financial: {
    per: { name: 'PER', value: '' },
    pbr: { name: 'PBR', value: '' },
    roe: { name: 'ROE', value: '' },
  },
  macro: {
    gdp: { name: 'GDP', value: '536.8兆円' },
    cpi: { name: 'CPI', value: '104.3' },
    iip: { name: '鉱工業生産指数', value: '97.9' },
    housing: { name: '住宅着工件数', value: '860,000戸' },
  },
}

const Metrics = ({ onOpenMetricSidebar, metricsData, widgetId }) => {
  const [metrics, setMetrics] = useState([
    { id: 'default_1', category: '', subCategory: '' },
    { id: 'default_2', category: '', subCategory: '' },
    { id: 'default_3', category: '', subCategory: '' },
    { id: 'default_4', category: '', subCategory: '' },
  ])

  useEffect(() => {
    setMetrics(prevMetrics => prevMetrics.map(metric => ({
      ...metric,
      ...metricsData[metric.id]
    })))
  }, [metricsData])

  const addMetric = () => {
    const newMetric = { id: `metric-${Date.now()}`, category: '', subCategory: '' }
    setMetrics([...metrics, newMetric])
  }

  const removeMetric = (id) => {
    setMetrics(metrics.filter(m => m.id !== id))
  }

  const getMetricValue = (metric) => {
    if (metric.category && metric.subCategory) {
      return subCategories[metric.category][metric.subCategory]?.value || '-'
    }
    return '-'
  }

  return (
    <div className="p-4 w-full relative">
      <div className="flex items-center mb-4">
        <h4 className="text-lg font-semibold">主要指標</h4>
        <button
          className="ml-2 p-1 rounded-full bg-gray-500 text-white hover:bg-gray-600"
          onClick={addMetric}
          aria-label="指標を追加"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
      <div className="flex flex-wrap gap-4">
        {metrics.map(metric => (
          <div key={metric.id} className="bg-white p-3 rounded relative shadow metric flex-grow flex-shrink min-w-[250px]">
            <button
              className="absolute top-1 right-1 text-gray-500 hover:text-gray-700"
              onClick={() => removeMetric(metric.id)}
              aria-label="指標を削除"
            >
              <X className="w-4 h-4" />
            </button>
            {metric.category && metric.subCategory ? (
              <>
                <p className="text-sm text-gray-600">{categories[metric.category]}</p>
                <p className="text-lg font-semibold">{subCategories[metric.category][metric.subCategory].name}</p>
                <p className="text-xl font-bold mt-2">{getMetricValue(metric)}</p>
              </>
            ) : (
              <button
                className="w-full h-full flex items-center justify-center text-gray-500 hover:text-gray-700"
                onClick={() => onOpenMetricSidebar(metric.id)}
              >
                指標を選択してください
              </button>
            )}
          </div>
        ))}
      </div>

      <style jsx>{`
        @media (max-width: 768px) {
          .metric {
            flex-basis: calc(50% - 1rem);
          }
        }
        @media (max-width: 480px) {
          .metric {
            flex-basis: 100%;
          }
        }
      `}</style>
    </div>
  )
}

export default Metrics

